export { Delivery as default, getStaticProps } from '@cinch-nx/feature-delivery'
